import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import AICoachChat from "./AICoachChat";
import { Crosshair, Books, Barbell, Sparkle, SignOut, UserCircle, Users, GraduationCap, ChartBar, ChartLineUp } from "@phosphor-icons/react";

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: Crosshair, testid: "nav-dashboard" },
  { to: "/library", label: "Library", icon: Books, testid: "nav-library" },
  { to: "/builder", label: "Plan Builder", icon: Barbell, testid: "nav-builder" },
  { to: "/ai", label: "AI Coach", icon: Sparkle, testid: "nav-ai" },
  { to: "/assessment", label: "Assessment", icon: ChartBar, testid: "nav-assessment" },
  { to: "/tutorial", label: "Tutorial", icon: GraduationCap, testid: "nav-tutorial" },
  { to: "/community", label: "Community", icon: Users, testid: "nav-community" },
];

const adminNavItem = { to: "/admin/analytics", label: "Analytics", icon: ChartLineUp, testid: "nav-analytics" };

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const items = user?.role === "admin" ? [...navItems, adminNavItem] : navItems;

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-40 border-b border-border bg-card/85 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4 gap-4">
          <Link to="/dashboard" className="flex items-center gap-3 shrink-0" data-testid="brand-link">
            <img src="/icon-192.png" alt="TP" className="w-9 h-9 object-contain" />
            <div className="leading-none hidden lg:block">
              <div className="font-display text-2xl font-black tracking-tight">TACTICAL</div>
              <div className="label-mono">PROGRESSION</div>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-1 flex-wrap justify-end">
            {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `px-3 py-2 font-display uppercase tracking-wider text-xs lg:text-sm flex items-center gap-1.5 border whitespace-nowrap ${
                    isActive
                      ? "border-volt text-volt"
                      : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
                  }`
                }
              >
                <it.icon size={14} weight="bold" /> {it.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            {user && (
              <Link to="/profile" className="hidden sm:flex items-center gap-2 text-sm text-muted-foreground hover:text-volt transition-colors" data-testid="profile-link">
                <UserCircle size={20} weight="bold" />
                <span data-testid="user-name">{user.name}</span>
              </Link>
            )}
            <button
              onClick={async () => { await logout(); navigate("/login"); }}
              className="px-3 py-2 border border-border text-xs uppercase tracking-widest hover:border-volt hover:text-volt transition-colors flex items-center gap-2"
              data-testid="logout-btn"
            >
              <SignOut size={14} weight="bold" /> Logout
            </button>
          </div>
        </div>
        <div className="md:hidden border-t border-border flex overflow-x-auto">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              className={({ isActive }) =>
                `px-4 py-3 font-display uppercase text-xs flex items-center gap-2 ${
                  isActive ? "text-volt" : "text-muted-foreground"
                }`
              }
            >
              <it.icon size={14} weight="bold" /> {it.label}
            </NavLink>
          ))}
        </div>
      </header>
      <main className="flex-1 max-w-7xl w-full mx-auto px-6 py-8">{children}</main>
      <footer className="border-t border-border py-4 text-center label-mono">
        TACTICAL PROGRESSION // FM 7-22 H2F DOCTRINE // BUILD YOUR MISSION
      </footer>
      <AICoachChat />
    </div>
  );
}
